import React, { useContext, useEffect, useState } from "react";
import ZingChart from "zingchart-react";
import $ from "jquery";
import { useParams, useLocation } from "react-router-dom";
import "../styles/previewDigitalPPTForList.css";
import availabilityImage from "../images/availability.png";
import locationImage from "../images/location_icon.png";
import experienceImage from "../images/experience.png";
import rateImage from "../images/rate.png";
import ephLogo from "../images/logo-min.png";
import LoadingIcon from "../images/Loading_icon.gif";
import Swal from "sweetalert2";
import ExistingDigitalBtn from "../components/PreviewDigitalPPTForList/ExistingDigitalBtn";
import ExpertImage from "../components/PreviewDigitalPPTForList/ExpertImage";
import ExpertLogo1 from "../components/PreviewDigitalPPTForList/ExpertLogo1";
import ExpertLogo2 from "../components/PreviewDigitalPPTForList/ExpertLogo2";
import ExpertLogo3 from "../components/PreviewDigitalPPTForList/ExpertLogo3";
import ExpertLogo4 from "../components/PreviewDigitalPPTForList/ExpertLogo4";
import ExpertLogo5 from "../components/PreviewDigitalPPTForList/ExpertLogo5";
import ExpertLogo6 from "../components/PreviewDigitalPPTForList/ExpertLogo6";
import ExpertLogo7 from "../components/PreviewDigitalPPTForList/ExpertLogo7";
// import AutomatedSummary from '../components/PreviewDigitalPPT/AutomatedSummary';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import successIcon from "../images/successGreenIcon.png";
import errorIcon from "../images/errorRedIcon.png";
import { UrlContext } from "../contexts/UrlContext";
import ExpertPowerPointExperience from "../components/PreviewDigitalPPT/ExpertPowerPointExperience";

const modules = {
  toolbar: [[{ list: "ordered" }, { list: "bullet" }]],
};

const formats = ["list"];

export default function PreviewDigitalPPTForList() {
  useEffect(() => {
    document.title = "Preview Digital PPT";
  }, []);

  const proj_id = useParams().proj_id;
  const exp_id = useParams().exp_id;
  const exprj_id = useParams().exprj_id;
  const location = useLocation();
  const { API_URL } = useContext(UrlContext);
  const [exDigitalID, setExDigitalID] = useState("");
  const [exDigitalIDSuccess, setExDigitalIDSuccess] = useState(false);
  const [exDigitalIDError, setExDigitalIDError] = useState(false);
  const [exDigitalIDLoading, setExDigitalIDLoading] = useState(false);

  const [exPosition, setExPosition] = useState("");
  const [exPositionSuccess, setExPositionSuccess] = useState(false);
  const [exPositionError, setExPositionError] = useState(false);
  const [exPositionLoading, setExPositionLoading] = useState(false);

  const [exLocation, setExLocation] = useState("");
  const [exLocationSuccess, setExLocationSuccess] = useState(false);
  const [exLocationError, setExLocationError] = useState(false);
  const [exLocationLoading, setExLocationLoading] = useState(false);

  const [exTotalExperience, setExTotalExperience] = useState("");
  const [exTotalExperienceSuccess, setExTotalExperienceSuccess] =
    useState(false);
  const [exTotalExperienceError, setExTotalExperienceError] = useState(false);
  const [exTotalExperienceLoading, setExTotalExperienceLoading] =
    useState(false);

  const [exAvailableComment, setExAvailableComment] = useState("");
  const [exAvailableCommentSuccess, setExAvailableCommentSuccess] =
    useState(false);
  const [exAvailableCommentError, setExAvailableCommentError] = useState(false);
  const [exAvailableCommentLoading, setExAvailableCommentLoading] =
    useState(false);

  const [exProjectCurrency, setExProjectCurrency] = useState("");
  const [exDailyRate, setExDailyRate] = useState("");
  const [exBillingFrequency, setExBillingFrequency] = useState("");
  const [exFootNote, setExFootNote] = useState("");
  const [exDailyRateSuccess, setExDailyRateSuccess] = useState(false);
  const [exDailyRateError, setExDailyRateError] = useState(false);
  const [exDailyRateLoading, setExDailyRateLoading] = useState(false);

  const [exSummary, setExSummary] = useState("");
  const [exSummarySuccess, setExSummarySuccess] = useState(false);
  const [exSummaryError, setExSummaryError] = useState(false);
  const [exSummaryLoading, setExSummaryLoading] = useState(false);

  const [exExperience, setExExperience] = useState("");
  const [exExperienceSuccess, setExExperienceSuccess] = useState(false);
  const [exExperienceError, setExExperienceError] = useState(false);
  const [exExperienceLoading, setExExperienceLoading] = useState(false);

  const [exEducation, setExEducation] = useState("");
  const [exEducationSuccess, setExEducationSuccess] = useState(false);
  const [exEducationError, setExEducationError] = useState(false);
  const [exEducationLoading, setExEducationLoading] = useState(false);

  const [prjDimension1, setPrjDimension1] = useState("");
  const [prjDimension1Success, setPrjDimension1Success] = useState(false);
  const [prjDimension1Error, setPrjDimension1Error] = useState(false);
  const [prjDimension1Loading, setPrjDimension1Loading] = useState(false);

  const [prjDimension2, setPrjDimension2] = useState("");
  const [prjDimension2Success, setPrjDimension2Success] = useState(false);
  const [prjDimension2Error, setPrjDimension2Error] = useState(false);
  const [prjDimension2Loading, setPrjDimension2Loading] = useState(false);

  const [prjDimension3, setPrjDimension3] = useState("");
  const [prjDimension3Success, setPrjDimension3Success] = useState(false);
  const [prjDimension3Error, setPrjDimension3Error] = useState(false);
  const [prjDimension3Loading, setPrjDimension3Loading] = useState(false);

  const [prjDimension4, setPrjDimension4] = useState("");
  const [prjDimension4Success, setPrjDimension4Success] = useState(false);
  const [prjDimension4Error, setPrjDimension4Error] = useState(false);
  const [prjDimension4Loading, setPrjDimension4Loading] = useState(false);

  const [prjDimension5, setPrjDimension5] = useState("");
  const [prjDimension5Success, setPrjDimension5Success] = useState(false);
  const [prjDimension5Error, setPrjDimension5Error] = useState(false);
  const [prjDimension5Loading, setPrjDimension5Loading] = useState(false);

  const [exProfilePicture, setExProfilePicture] = useState("");
  const [exLogo1, setExLogo1] = useState("");
  const [exLogo2, setExLogo2] = useState("");
  const [exLogo3, setExLogo3] = useState("");
  const [exLogo4, setExLogo4] = useState("");
  const [exLogo5, setExLogo5] = useState("");
  const [exLogo6, setExLogo6] = useState("");
  const [exLogo7, setExLogo7] = useState("");

  const [powerPointID, setPowerPointID] = useState(null);

  const showDivBasedOnUrl = () => {
    const { pathname } = location;
    if (pathname.includes("/PreviewDigitalPPTForList")) {
      // Render div for PreviewDigitalPPT
      return (
        <div className="ppt-previewBtn-div">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => window.close()}
          >
            Close
          </button>
          <ExistingDigitalBtn exp_id={exp_id} proj_id={proj_id} />
          {/* <AutomatedSummary exp_id={exp_id} proj_id={proj_id} exSummary={exSummary} /> */}
          {/* <button type="button" className="btn base-btn" onClick={handleSaveButton} >Save</button> */}
          {/* <button
            type="button"
            className="btn base-btn"
            onClick={handleDownloadButton}
          >
            Download
          </button>
          <div className="updateinfo-ppt-div">
            <button
              type="button"
              className="btn base-btn"
              onClick={handleUpdateButton}
            >
              Get Info
            </button>
            <span className="updateinfo-ppt-tooltiptext">
              This action will delete all current changes and replace them with
              expert profile's information from Database!
            </span>
          </div> */}
        </div>
      );
    } else if (pathname.includes("/ExistingDigitalPPTForList")) {
      // Render div for ExistingDigitalPPT
      return (
        <div className="ppt-previewBtn-div">
          <b style={{ color: "#cb2121" }}>
            This is a Read-only existing digital PPT. Changes will not be saved.
            You can only copy information and images manually.
          </b>
        </div>
      );
    }
  };

  const [pptDownloading, setPptDownloading] = useState(false);
  const [digitalUpdating, setDigitalUpdating] = useState(false);
  // const [pptSaving, setPptSaving] = useState(false)
  // const [project, setProject] = useState({})
  const [showRateDimensionPopup, setShowRateDimensionPopup] = useState(false);
  const [chartConfig, setChartConfig] = useState({});
  const [ratingObj, setRatingObj] = useState({
    rating1: 0,
    rating2: 0,
    rating3: 0,
    rating4: 0,
    rating5: 0,
  });
  const [ratingObjSuccess, setRatingObjSuccess] = useState(false);
  const [ratingObjError, setRatingObjError] = useState(false);
  const [ratingObjLoading, setRatingObjLoading] = useState(false);

  const handleDownloadButton = () => {
    setPptDownloading(true);
    const authToken = localStorage.getItem("accesstoken");
    const url = `${API_URL}download-digital-ppt-for-list`;
    const data = {
      proj_id,
      exp_id,
      authToken,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setPptDownloading(false);
        if (data.status === "success") {
          window.open(data.fileUrl);
        }
        if (data.status === "error") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            timer: 1500,
            showConfirmButton: false,
          });
        }
      })
      .catch((err) => {
        setPptDownloading(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          timer: 1500,
          showConfirmButton: false,
        });
      });
  };

  const handleUpdateButton = () => {
    setDigitalUpdating(true);
    const url = `${API_URL}update-digital-ppt-for-list`;
    const data = {
      proj_id,
      exp_id,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setDigitalUpdating(false);
        if (data.status === "success") {
          window.location.reload();
        } else if (data.status === "error") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            timer: 1500,
            showConfirmButton: false,
          });
        }
      })
      .catch((err) => {
        setDigitalUpdating(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          timer: 1500,
          showConfirmButton: false,
        });
      });
  };

  $(document).ready(function () {
    $("#myChart-graph-id0-scale_k-item_0").children().eq(0).html(1);
    $("#myChart-graph-id0-scale_k-item_1").children().eq(0).html(2);
    $("#myChart-graph-id0-scale_k-item_2").children().eq(0).html(3);
    $("#myChart-graph-id0-scale_k-item_3").children().eq(0).html(4);
    $("#myChart-graph-id0-scale_k-item_4").children().eq(0).html(5);

    function enableTab(id) {
      const el = document.getElementById(id);
      el.onkeydown = function (e) {
        if (e.keyCode === 9) {
          e.preventDefault();
          const val = this.value;
          const start = this.selectionStart;
          const end = this.selectionEnd;

          let newValue;
          let newCursorPosition;

          if (id === "ppt-expertSummery") {
            newValue = val.substring(0, start) + "\n     " + val.substring(end);
            newCursorPosition = start + 6;
          } else {
            newValue = val.substring(0, start) + "     " + val.substring(end);
            newCursorPosition = start + 5;
          }
          this.value = newValue;
          this.setSelectionRange(newCursorPosition, newCursorPosition);
          return false;
        }
      };
    }
    enableTab("ppt-expertSummery");
    // enableTab("ppt-expertExperience");
    enableTab("ppt-expert-education");
  });

  useEffect(() => {
    // const chartConfig = {
    //   type: "radar",
    //   plot: {
    //     aspect: "area",
    //     stacked: "no",
    //   },
    //   scaleK: {
    //     aspect: "star",
    //   },
    //   scaleV: {
    //     values: ":5:4:3:2:1",
    //   },
    //   series: [
    //     {
    //       values: [
    //         parseInt(ratingObj?.rating1),
    //         parseInt(ratingObj?.rating2),
    //         parseInt(ratingObj?.rating3),
    //         parseInt(ratingObj?.rating4),
    //         parseInt(ratingObj?.rating5),
    //       ],
    //     },
    //   ],
    //   height: "230px",
    //   width: "230px",
    // };
    const totalRating = parseInt(ratingObj?.rating1) + parseInt(ratingObj?.rating2) + parseInt(ratingObj?.rating3) + parseInt(ratingObj?.rating4) + parseInt(ratingObj?.rating5)
    const MatchingCo = (totalRating/25) *100;
    const chartConfig = {
      type: "radar",
      title: {
        text: MatchingCo.toString()+"%",
        y: "110px",
        fontColor: "white",
        border: "5px solid white",
        borderRadius: "25px",
        width: "20%",
        height: "20%",
        fontSize: "10px"
      },
      plot: {
        aspect: "area",
        stacked: "no",
      },
      scaleK: {
        aspect: "star",
        labels: ["1", "2", "3", "4", "5"],
        tick: {
          'line-width': "0",
        }
      },
      scaleV: {
        values: "0:5:1",
        guide:{
          'line-color': "lightgrey",
        },
        item: {
          fontSize: "0",
        },
        tick: {
          size: "0"
        },
        refLine: {
          lineColor: "none"
        },
        guide: {
          lineStyle: "dashdot"
        }
      },
      series: [
        {
          values: [
            parseInt(ratingObj?.rating1),
            parseInt(ratingObj?.rating2),
            parseInt(ratingObj?.rating3),
            parseInt(ratingObj?.rating4),
            parseInt(ratingObj?.rating5),
          ],
          lineColor: "#365561",
          backgroundColor: "#365561",
          alphaArea: "1",
          marker: {
            backgroundColor: "none",
            size: "0",
            borderColor: "none"
          }
        },
      ],
      height: "230px",
      width: "230px",
      backgroundColor: "none"
    };
    setChartConfig(chartConfig);
  }, [ratingObj]);

  useEffect(() => {
    const url = `${API_URL}list-title/` + proj_id;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        // setProject(data.project)
        setPrjDimension1(data.project.dimension1);
        setPrjDimension2(data.project.dimension2);
        setPrjDimension3(data.project.dimension3);
        setPrjDimension4(data.project.dimension4);
        setPrjDimension5(data.project.dimension5);
      })
      .catch((err) => console.log(err));
  }, []);

  // useEffect(() => {
  //   const url = `${API_URL}projet-expert-digital-ppt-for-list/${proj_id}/${exp_id}/${exprj_id}`;
  //   fetch(url, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setPowerPointID(data.ID);
  //       setExDigitalID(data.expertDigitalID);
  //       setExPosition(data.position);
  //       setExLocation(data.location);
  //       setExTotalExperience(data.totalExperience);
  //       setExAvailableComment(data.Available_comment);
  //       setExProjectCurrency(data.projectCurrency);
  //       setExDailyRate(data.daily_rate);
  //       setExBillingFrequency(data.billingFrequency);
  //       setExFootNote(data.footNote);
  //       setExSummary(data.summ);
  //       setExExperience(data.experience);
  //       setExEducation(data.education);
  //       setExProfilePicture(data.profilePicture);
  //       setExLogo1(data.logo1);
  //       setExLogo2(data.logo2);
  //       setExLogo3(data.logo3);
  //       setExLogo4(data.logo4);
  //       setExLogo5(data.logo5);
  //       setExLogo6(data.logo6);
  //       setExLogo7(data.logo7);

  //       setRatingObj({
  //         rating1: data.rating1,
  //         rating2: data.rating2,
  //         rating3: data.rating3,
  //         rating4: data.rating4,
  //         rating5: data.rating5,
  //       });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  useEffect(() => {
    const url = `${API_URL}view-digital-profile-for-list/${exp_id}/${proj_id}`;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 'success') {
          setPowerPointID(data.powerpointData.ID);
          setExDigitalID(data.powerpointData.expertDigitalID);
          setExPosition(data.powerpointData.position);
          setExLocation(data.powerpointData.location);
          setExTotalExperience(data.powerpointData.totalExperience);
          setExAvailableComment(data.powerpointData.Available_comment);
          setExProjectCurrency(data.powerpointData.projectCurrency);
          setExDailyRate(data.powerpointData.daily_rate);
          setExBillingFrequency(data.powerpointData.billingFrequency);
          setExFootNote(data.powerpointData.footNote);
          setExSummary(data.powerpointData.summ);
          setExExperience(data.powerpointData.experience);
          setExEducation(data.powerpointData.education);
          setExProfilePicture(data.powerpointData.profilePicture);
          setRatingObj({
            rating1: data.powerpointData.rating1,
            rating2: data.powerpointData.rating2,
            rating3: data.powerpointData.rating3,
            rating4: data.powerpointData.rating4,
            rating5: data.powerpointData.rating5,
          });
        } else {
          console.log('Error while fetching data!')
          Swal.fire({
            title: "Error!",
            text: data.text,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // function addBulletPoint(textareaId) {
  //   let textarea = document.getElementById(textareaId);
  //   setExpertData((prevData) => {
  //     const currentValue = prevData.summ || '';
  //     const cursorPosition = textarea.selectionStart;
  //     const newValue = currentValue.substring(0, cursorPosition) + "  ● " + currentValue.substring(cursorPosition);

  //     return { ...prevData, summ: newValue };
  //   });
  // }
  // function addSpacePoint(textareaId) {
  //   let textarea = document.getElementById(textareaId);
  //   setExpertData((prevData) => {
  //     const currentValue = prevData.summ || '';
  //     const cursorPosition = textarea.selectionStart;
  //     let newValue;

  //     if (textareaId === 'ppt-expertSummery') {
  //       newValue = currentValue.substring(0, cursorPosition) + "\n     " + currentValue.substring(cursorPosition);
  //     } else {
  //       newValue = currentValue.substring(0, cursorPosition) + "     " + currentValue.substring(cursorPosition);
  //     }

  //     return { ...prevData, summ: newValue };
  //   });
  // }

  const autoGrow = (event) => {
    const element = event.target;
    element.style.height = "5px";
    element.style.height = `${element.scrollHeight}px`;
  };

  useEffect(() => {
    setTimeout(() => {
      $("#ppt-expertExperience").trigger("click");
      $("#ppt-expert-education").trigger("click");
    }, 1800);

    // setTimeout(() => {
    //   const expertAvailableInput = document.getElementsByClassName('ex-available-text')[0];
    //   if (expertAvailableInput.value === '' || expertAvailableInput.value === null) {
    //     setExpertData((prevData) => {
    //       return { ...prevData, Available_comment: 'Available' };
    //     });
    //   }
    // }, 1000);
  }, []);

  const removeFormatting = (e) => {
    e.preventDefault();
    const text = e.clipboardData.getData("text/plain");
    document.execCommand("insertText", false, text);
  };

  const saveExDigitalID = () => {
    setExDigitalIDError(false);
    setExDigitalIDLoading(true);
    const url = `${API_URL}ppt-save-expert-digital-id-for-list`;
    const data = {
      proj_id: proj_id,
      exp_id: exp_id,
      expertDigitalID: exDigitalID,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setExDigitalIDLoading(false);
        if (data.status === "success") {
          setExDigitalIDSuccess(true);
          setTimeout(() => {
            setExDigitalIDSuccess(false);
          }, 1500);
        } else {
          setExDigitalIDError(true);
        }
      })
      .catch((err) => {
        setExDigitalIDLoading(false);
        setExDigitalIDError(true);
      });
  };

  const saveExPosition = () => {
    setExPositionError(false);
    setExPositionLoading(true);
    const url = `${API_URL}ppt-save-expert-position-for-list`;
    const data = {
      proj_id: proj_id,
      exp_id: exp_id,
      position: exPosition,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setExPositionLoading(false);
        if (data.status === "success") {
          setExPositionSuccess(true);
          setTimeout(() => {
            setExPositionSuccess(false);
          }, 1500);
        } else {
          setExPositionError(true);
        }
      })
      .catch((err) => {
        setExPositionLoading(false);
        setExPositionError(true);
      });
  };

  const saveExLocation = () => {
    setExLocationError(false);
    setExLocationLoading(true);
    const url = `${API_URL}ppt-save-expert-location-for-list`;
    const data = {
      proj_id: proj_id,
      exp_id: exp_id,
      location: exLocation,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setExLocationLoading(false);
        if (data.status === "success") {
          setExLocationSuccess(true);
          setTimeout(() => {
            setExLocationSuccess(false);
          }, 1500);
        } else {
          setExLocationError(true);
        }
      })
      .catch((err) => {
        setExLocationLoading(false);
        setExLocationError(true);
      });
  };

  const saveExTotalExperience = () => {
    setExTotalExperienceError(false);
    setExTotalExperienceLoading(true);
    const url = `${API_URL}ppt-save-expert-total-experience-for-list`;
    const data = {
      proj_id: proj_id,
      exp_id: exp_id,
      totalExperience: exTotalExperience,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setExTotalExperienceLoading(false);
        if (data.status === "success") {
          setExTotalExperienceSuccess(true);
          setTimeout(() => {
            setExTotalExperienceSuccess(false);
          }, 1500);
        } else {
          setExTotalExperienceError(true);
        }
      })
      .catch((err) => {
        setExTotalExperienceLoading(false);
        setExTotalExperienceError(true);
      });
  };

  const saveExAvailableComment = () => {
    setExAvailableCommentError(false);
    setExAvailableCommentLoading(true);
    const url = `${API_URL}ppt-save-expert-available-comment-for-list`;
    const data = {
      proj_id: proj_id,
      exp_id: exp_id,
      Available_comment: exAvailableComment,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setExAvailableCommentLoading(false);
        if (data.status === "success") {
          setExAvailableCommentSuccess(true);
          setTimeout(() => {
            setExAvailableCommentSuccess(false);
          }, 1500);
        } else {
          setExAvailableCommentError(true);
        }
      })
      .catch((err) => {
        setExAvailableCommentLoading(false);
        setExAvailableCommentError(true);
      });
  };

  const saveExProjectCurrency = (currency) => {
    setExDailyRateError(false);
    setExDailyRateLoading(true);
    const url = `${API_URL}ppt-save-expert-project-currency-for-list`;
    const data = {
      proj_id: proj_id,
      exp_id: exp_id,
      projectCurrency: currency,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setExDailyRateLoading(false);
        if (data.status === "success") {
          setExDailyRateSuccess(true);
          setTimeout(() => {
            setExDailyRateSuccess(false);
          }, 1500);
        } else {
          setExDailyRateError(true);
        }
      })
      .catch((err) => {
        setExDailyRateLoading(false);
        setExDailyRateError(true);
      });
  };

  const saveExDailyRate = () => {
    setExDailyRateError(false);
    setExDailyRateLoading(true);
    const url = `${API_URL}ppt-save-expert-daily-rate-for-list`;
    const data = {
      proj_id: proj_id,
      exp_id: exp_id,
      daily_rate: exDailyRate,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setExDailyRateLoading(false);
        if (data.status === "success") {
          setExDailyRateSuccess(true);
          setTimeout(() => {
            setExDailyRateSuccess(false);
          }, 1500);
        } else {
          setExDailyRateError(true);
        }
      })
      .catch((err) => {
        setExDailyRateLoading(false);
        setExDailyRateError(true);
      });
  };

  const saveExBillingFrequency = () => {
    setExDailyRateError(false);
    setExDailyRateLoading(true);
    const url = `${API_URL}ppt-save-expert-billing-frequency-for-list`;
    const data = {
      proj_id: proj_id,
      exp_id: exp_id,
      billingFrequency: exBillingFrequency,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setExDailyRateLoading(false);
        if (data.status === "success") {
          setExDailyRateSuccess(true);
          setTimeout(() => {
            setExDailyRateSuccess(false);
          }, 1500);
        } else {
          setExDailyRateError(true);
        }
      })
      .catch((err) => {
        setExDailyRateLoading(false);
        setExDailyRateError(true);
      });
  };

  const saveExFootNote = (footNote) => {
    setExDailyRateError(false);
    setExDailyRateLoading(true);
    const url = `${API_URL}ppt-save-expert-foot-note-for-list`;
    const data = {
      proj_id: proj_id,
      exp_id: exp_id,
      footNote: footNote,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setExDailyRateLoading(false);
        if (data.status === "success") {
          setExDailyRateSuccess(true);
          setTimeout(() => {
            setExDailyRateSuccess(false);
          }, 1500);
        } else {
          setExDailyRateError(true);
        }
      })
      .catch((err) => {
        setExDailyRateLoading(false);
        setExDailyRateError(true);
      });
  };

  const saveExSummary = () => {
    setExSummaryError(false);
    setExSummaryLoading(true);
    const url = `${API_URL}ppt-save-expert-summary-for-list`;
    const data = {
      proj_id: proj_id,
      exp_id: exp_id,
      summ: exSummary,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setExSummaryLoading(false);
        if (data.status === "success") {
          setExSummarySuccess(true);
          setTimeout(() => {
            setExSummarySuccess(false);
          }, 1500);
        } else {
          setExSummaryError(true);
        }
      })
      .catch((err) => {
        setExSummaryLoading(false);
        setExSummaryError(true);
      });
  };

  const saveExExperience = () => {
    setExExperienceError(false);
    setExExperienceLoading(true);
    const url = `${API_URL}ppt-save-expert-experience-for-list`;
    const data = {
      proj_id: proj_id,
      exp_id: exp_id,
      experience: exExperience,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setExExperienceLoading(false);
        if (data.status === "success") {
          setExExperienceSuccess(true);
          setTimeout(() => {
            setExExperienceSuccess(false);
          }, 1500);
        } else {
          setExExperienceError(true);
        }
      })
      .catch((err) => {
        setExExperienceLoading(false);
        setExExperienceError(true);
      });
  };

  const saveExEducation = () => {
    setExEducationError(false);
    setExEducationLoading(true);
    const url = `${API_URL}ppt-save-expert-education-for-list`;
    const data = {
      proj_id: proj_id,
      exp_id: exp_id,
      education: exEducation,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setExEducationLoading(false);
        if (data.status === "success") {
          setExEducationSuccess(true);
          setTimeout(() => {
            setExEducationSuccess(false);
          }, 1500);
        } else {
          setExEducationError(true);
        }
      })
      .catch((err) => {
        setExEducationLoading(false);
        setExEducationError(true);
      });
  };

  const savePrjDimension1 = () => {
    setPrjDimension1Error(false);
    setPrjDimension1Loading(true);
    const url = `${API_URL}save-dimension1/` + proj_id;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ dimension1: prjDimension1 }),
    })
      .then((res) => res.json())
      .then((data) => {
        setPrjDimension1Loading(false);
        if (data.status === "success") {
          setPrjDimension1Success(true);
          setTimeout(() => {
            setPrjDimension1Success(false);
          }, 1500);
        } else {
          setPrjDimension1Error(true);
        }
      })
      .catch((err) => {
        setPrjDimension1Loading(false);
        setPrjDimension1Error(true);
      });
  };

  const savePrjDimension2 = () => {
    setPrjDimension2Error(false);
    setPrjDimension2Loading(true);
    const url = `${API_URL}save-dimension2/` + proj_id;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ dimension2: prjDimension2 }),
    })
      .then((res) => res.json())
      .then((data) => {
        setPrjDimension2Loading(false);
        if (data.status === "success") {
          setPrjDimension2Success(true);
          setTimeout(() => {
            setPrjDimension2Success(false);
          }, 1500);
        } else {
          setPrjDimension2Error(true);
        }
      })
      .catch((err) => {
        setPrjDimension2Loading(false);
        setPrjDimension2Error(true);
      });
  };

  const savePrjDimension3 = () => {
    setPrjDimension3Error(false);
    setPrjDimension3Loading(true);
    const url = `${API_URL}save-dimension3/` + proj_id;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ dimension3: prjDimension3 }),
    })
      .then((res) => res.json())
      .then((data) => {
        setPrjDimension3Loading(false);
        if (data.status === "success") {
          setPrjDimension3Success(true);
          setTimeout(() => {
            setPrjDimension3Success(false);
          }, 1500);
        } else {
          setPrjDimension3Error(true);
        }
      })
      .catch((err) => {
        setPrjDimension3Loading(false);
        setPrjDimension3Error(true);
      });
  };

  const savePrjDimension4 = () => {
    setPrjDimension4Error(false);
    setPrjDimension4Loading(true);
    const url = `${API_URL}save-dimension4/` + proj_id;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ dimension4: prjDimension4 }),
    })
      .then((res) => res.json())
      .then((data) => {
        setPrjDimension4Loading(false);
        if (data.status === "success") {
          setPrjDimension4Success(true);
          setTimeout(() => {
            setPrjDimension4Success(false);
          }, 1500);
        } else {
          setPrjDimension4Error(true);
        }
      })
      .catch((err) => {
        setPrjDimension4Loading(false);
        setPrjDimension4Error(true);
      });
  };

  const savePrjDimension5 = () => {
    setPrjDimension5Error(false);
    setPrjDimension5Loading(true);
    const url = `${API_URL}save-dimension5/` + proj_id;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ dimension5: prjDimension5 }),
    })
      .then((res) => res.json())
      .then((data) => {
        setPrjDimension5Loading(false);
        if (data.status === "success") {
          setPrjDimension5Success(true);
          setTimeout(() => {
            setPrjDimension5Success(false);
          }, 1500);
        } else {
          setPrjDimension5Error(true);
        }
      })
      .catch((err) => {
        setPrjDimension5Loading(false);
        setPrjDimension5Error(true);
      });
  };

  const saveExRatingObj = () => {
    setRatingObjError(false);
    setRatingObjLoading(true);
    const url = `${API_URL}ppt-save-expert-rating-obj-for-list`;
    const data = {
      proj_id: proj_id,
      exp_id: exp_id,
      ratingObj: ratingObj,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setRatingObjLoading(false);
        if (data.status === "success") {
          setRatingObjSuccess(true);
          setTimeout(() => {
            setRatingObjSuccess(false);
            setShowRateDimensionPopup(false);
          }, 700);
        } else {
          setRatingObjError(true);
        }
      })
      .catch((err) => {
        setRatingObjLoading(false);
        setRatingObjError(true);
      });
  };

  return (
    <>
      <div className="ppt-main-container">
        <div className="tab-pane fade show previewNewPPT-div">
          <div className="mainPPT-div">
            <div className="leftPart-PPT">
              <center>
                <ExpertImage
                  proj_id={proj_id}
                  exp_id={exp_id}
                  exProfilePicture={exProfilePicture}
                  setExProfilePicture={setExProfilePicture}
                />
                <div className="position-relative">
                  <label
                    htmlFor="expertDigitalID"
                    className="input-title-info-label"
                  >
                    EPH_CON_
                  </label>
                  <input
                    id="expertDigitalID"
                    className="input-title-info"
                    value={exDigitalID}
                    onChange={(e) => {
                      // setExpertData({ ...expertData, expertDigitalID: e.target.value })
                      setExDigitalID(e.target.value);
                    }}
                    onBlur={saveExDigitalID}
                  />
                  {exDigitalIDLoading && (
                    <img
                      className="return-msg-icon"
                      style={{ top: "6px", right: "1px" }}
                      src={LoadingIcon}
                      alt="loading"
                      title="Loading..."
                    />
                  )}
                  {exDigitalIDSuccess && (
                    <img
                      className="return-msg-icon"
                      style={{ top: "6px", right: "1px" }}
                      src={successIcon}
                      alt="success"
                      title="Success"
                    />
                  )}
                  {exDigitalIDError && (
                    <img
                      className="return-msg-icon"
                      style={{ top: "6px", right: "1px" }}
                      src={errorIcon}
                      alt="error"
                      title="Error! Please reload"
                    />
                  )}
                </div>
                <div className="position-relative">
                  <textarea
                    maxLength={160}
                    value={exPosition}
                    onChange={(e) => {
                      // setExpertData({ ...expertData, position: e.target.value })
                      setExPosition(e.target.value);
                    }}
                    onBlur={saveExPosition}
                  />
                  {exPositionLoading && (
                    <img
                      className="return-msg-icon"
                      style={{ top: "6px", right: "1px" }}
                      src={LoadingIcon}
                      alt="loading"
                      title="Loading..."
                    />
                  )}
                  {exPositionSuccess && (
                    <img
                      className="return-msg-icon"
                      style={{ top: "6px", right: "1px" }}
                      src={successIcon}
                      alt="success"
                      title="Success"
                    />
                  )}
                  {exPositionError && (
                    <img
                      className="return-msg-icon"
                      style={{ top: "6px", right: "1px" }}
                      src={errorIcon}
                      alt="error"
                      title="Error! Please reload"
                    />
                  )}
                </div>
              </center>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <img
                        src={locationImage}
                        height="34px"
                        width="28px"
                        alt=""
                      />
                    </td>
                    <td style={{ paddingLeft: 0, position: "relative" }}>
                      <textarea
                        className="ppt-location-text"
                        maxLength={50}
                        value={exLocation}
                        onChange={(e) => {
                          // setExpertData({ ...expertData, location: e.target.value })
                          setExLocation(e.target.value);
                        }}
                        onInput={(e) => autoGrow(e)}
                        onBlur={saveExLocation}
                      />
                      {exLocationLoading && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "10px", right: "21px" }}
                          src={LoadingIcon}
                          alt="loading"
                          title="Loading..."
                        />
                      )}
                      {exLocationSuccess && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "10px", right: "21px" }}
                          src={successIcon}
                          alt="success"
                          title="Success"
                        />
                      )}
                      {exLocationError && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "10px", right: "21px" }}
                          src={errorIcon}
                          alt="error"
                          title="Error! Please reload"
                        />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <img src={experienceImage} height="28px" alt="" />
                    </td>
                    <td style={{ paddingLeft: 0, position: "relative" }}>
                      <label
                        className="totalExperienceLabel"
                        htmlFor="expertExperienceSum"
                      >
                        Total experience:{" "}
                      </label>
                      <input
                        id="expertExperienceSum"
                        maxLength={10}
                        value={exTotalExperience}
                        onChange={(e) => {
                          // setExpertData({ ...expertData, totalExperience: e.target.value })
                          setExTotalExperience(e.target.value);
                        }}
                        onBlur={saveExTotalExperience}
                      />
                      {exTotalExperienceLoading && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "6px", right: "21px" }}
                          src={LoadingIcon}
                          alt="loading"
                          title="Loading..."
                        />
                      )}
                      {exTotalExperienceSuccess && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "6px", right: "21px" }}
                          src={successIcon}
                          alt="success"
                          title="Success"
                        />
                      )}
                      {exTotalExperienceError && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "6px", right: "21px" }}
                          src={errorIcon}
                          alt="error"
                          title="Error! Please reload"
                        />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <img src={availabilityImage} height="26px" alt="" />
                    </td>
                    <td style={{ paddingLeft: 0, position: "relative" }}>
                      <textarea
                        className="ex-available-text"
                        maxLength={52}
                        value={exAvailableComment}
                        onChange={(e) => {
                          // setExpertData({ ...expertData, Available_comment: e.target.value })
                          setExAvailableComment(e.target.value);
                        }}
                        onInput={(e) => autoGrow(e)}
                        onBlur={saveExAvailableComment}
                      />
                      {exAvailableCommentLoading && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "10px", right: "21px" }}
                          src={LoadingIcon}
                          alt="loading"
                          title="Loading..."
                        />
                      )}
                      {exAvailableCommentSuccess && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "10px", right: "21px" }}
                          src={successIcon}
                          alt="success"
                          title="Success"
                        />
                      )}
                      {exAvailableCommentError && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "10px", right: "21px" }}
                          src={errorIcon}
                          alt="error"
                          title="Error! Please reload"
                        />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <img
                        src={rateImage}
                        height="28px"
                        width="30px"
                        style={{ marginBottom: "10px" }}
                        alt=""
                      />
                    </td>
                    <td style={{ paddingLeft: 0, position: "relative" }}>
                      <select
                        className="ppt-currency-daily"
                        value={exProjectCurrency}
                        onChange={(e) => {
                          // setExpertData({ ...expertData, projectCurrency: e.target.value })
                          setExProjectCurrency(e.target.value);
                          saveExProjectCurrency(e.target.value);
                        }}
                      >
                        <option value="">---</option>
                        <option value="EUR">EUR</option>
                        <option value="USD">USD</option>
                        <option value="GBP">GBP</option>
                        <option value="AUD">AUD</option>
                        <option value="AED">AED</option>
                        <option value="INR">INR</option>
                      </select>

                      <input
                        id="expertRate"
                        value={exDailyRate}
                        onChange={(e) => {
                          setExDailyRate(e.target.value);
                          // setExpertData({ ...expertData, daily_rate: e.target.value })
                        }}
                        onBlur={saveExDailyRate}
                      />
                      <input
                        id="expert-billing-Frequency-ppt"
                        value={exBillingFrequency}
                        onChange={(e) => {
                          // setExpertData({ ...expertData, billingFrequency: e.target.value })
                          setExBillingFrequency(e.target.value);
                        }}
                        onBlur={saveExBillingFrequency}
                      />

                      <span>{exFootNote === "yes" ? "*" : ""}</span>

                      <div className="bottom-border-for-ppt" style={{textAlign: "center", width: "100%", borderBottom: "1px solid #fff", marginLeft: "-14%"}}></div>

                      {exDailyRateLoading && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "6px", right: "21px" }}
                          src={LoadingIcon}
                          alt="loading"
                          title="Loading..."
                        />
                      )}
                      {exDailyRateSuccess && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "6px", right: "21px" }}
                          src={successIcon}
                          alt="success"
                          title="Success"
                        />
                      )}
                      {exDailyRateError && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "6px", right: "21px" }}
                          src={errorIcon}
                          alt="error"
                          title="Error! Please reload"
                        />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <input
                type="checkbox"
                id="eph-include"
                className="ppt-include-rates-checkbox"
                checked={exFootNote === "yes" ? true : false}
                onChange={(e) => {
                  setExFootNote(e.target.checked ? "yes" : "no");
                  saveExFootNote(e.target.checked ? "yes" : "no");
                }}
              />
              <span className="span-include-rates">
                <label
                  style={{ marginBottom: "0", cursor: "pointer" }}
                  htmlFor="eph-include"
                >
                  *rate includes EPH service
                </label>
              </span>
            </div>
            <div className="rightPart-PPT">
              <div className="ppt-header-div">
                <img src={ephLogo} alt="" />
              </div>

              {/*------ summary and requirement matching sections */}
              <div className="ppt-left-fixed-div">
                <div
                  className="ppt-summary-div position-relative"
                  style={{ zIndex: 8 }}
                >
                  <h5>EPH Professional Summary</h5>
                  <ReactQuill
                    theme="snow"
                    id="ppt-expertSummery"
                    modules={modules}
                    formats={formats}
                    value={exSummary}
                    onChange={(e) => setExSummary(e)}
                    onPaste={removeFormatting}
                    onBlur={saveExSummary}
                  />
                  {exSummaryLoading && (
                    <img
                      className="return-msg-icon"
                      style={{ top: "11px", right: "143px" }}
                      src={LoadingIcon}
                      alt="loading"
                      title="Loading..."
                    />
                  )}
                  {exSummarySuccess && (
                    <img
                      className="return-msg-icon"
                      style={{ top: "11px", right: "143px" }}
                      src={successIcon}
                      alt="success"
                      title="Success"
                    />
                  )}
                  {exSummaryError && (
                    <img
                      className="return-msg-icon"
                      style={{ top: "11px", right: "143px" }}
                      src={errorIcon}
                      alt="error"
                      title="Error! Please reload"
                    />
                  )}
                </div>
                <div
                  className="ppt-bottom-chart-div"
                  style={{ height: "196px" }}
                >
                  <h5>EPH Requirement Matching</h5>
                  <div className="ppt-dimensions-div">
                    <div className="position-relative">
                      <label style={{ marginTop: "56px" }}>1: </label>
                      <input
                        className="ppt-dimension1"
                        value={prjDimension1}
                        onChange={(e) => {
                          // setProject({ ...project, dimension1: e.target.value })
                          setPrjDimension1(e.target.value);
                        }}
                        onBlur={savePrjDimension1}
                      />
                      {prjDimension1Loading && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "47px", right: "-16px" }}
                          src={LoadingIcon}
                          alt="loading"
                          title="Loading..."
                        />
                      )}
                      {prjDimension1Success && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "47px", right: "-16px" }}
                          src={successIcon}
                          alt="success"
                          title="Success"
                        />
                      )}
                      {prjDimension1Error && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "47px", right: "-16px" }}
                          src={errorIcon}
                          alt="error"
                          title="Error! Please reload"
                        />
                      )}
                    </div>
                    <div className="position-relative">
                      <label>2: </label>
                      <input
                        className="ppt-dimension2"
                        value={prjDimension2}
                        onChange={(e) => {
                          // setProject({ ...project, dimension2: e.target.value })
                          setPrjDimension2(e.target.value);
                        }}
                        onBlur={savePrjDimension2}
                      />
                      {prjDimension2Loading && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "1px", right: "-16px" }}
                          src={LoadingIcon}
                          alt="loading"
                          title="Loading..."
                        />
                      )}
                      {prjDimension2Success && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "1px", right: "-16px" }}
                          src={successIcon}
                          alt="success"
                          title="Success"
                        />
                      )}
                      {prjDimension2Error && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "1px", right: "-16px" }}
                          src={errorIcon}
                          alt="error"
                          title="Error! Please reload"
                        />
                      )}
                    </div>
                    <div className="position-relative">
                      <label>3: </label>
                      <input
                        className="ppt-dimension3"
                        value={prjDimension3}
                        onChange={(e) => {
                          // setProject({ ...project, dimension3: e.target.value })
                          setPrjDimension3(e.target.value);
                        }}
                        onBlur={savePrjDimension3}
                      />
                      {prjDimension3Loading && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "1px", right: "-16px" }}
                          src={LoadingIcon}
                          alt="loading"
                          title="Loading..."
                        />
                      )}
                      {prjDimension3Success && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "1px", right: "-16px" }}
                          src={successIcon}
                          alt="success"
                          title="Success"
                        />
                      )}
                      {prjDimension3Error && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "1px", right: "-16px" }}
                          src={errorIcon}
                          alt="error"
                          title="Error! Please reload"
                        />
                      )}
                    </div>
                    <div className="position-relative">
                      <label>4: </label>
                      <input
                        className="ppt-dimension4"
                        value={prjDimension4}
                        onChange={(e) => {
                          // setProject({ ...project, dimension4: e.target.value })
                          setPrjDimension4(e.target.value);
                        }}
                        onBlur={savePrjDimension4}
                      />
                      {prjDimension4Loading && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "1px", right: "-16px" }}
                          src={LoadingIcon}
                          alt="loading"
                          title="Loading..."
                        />
                      )}
                      {prjDimension4Success && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "1px", right: "-16px" }}
                          src={successIcon}
                          alt="success"
                          title="Success"
                        />
                      )}
                      {prjDimension4Error && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "1px", right: "-16px" }}
                          src={errorIcon}
                          alt="error"
                          title="Error! Please reload"
                        />
                      )}
                    </div>
                    <div className="position-relative">
                      <label>5: </label>
                      <input
                        className="ppt-dimension5"
                        value={prjDimension5}
                        onChange={(e) => {
                          // setProject({ ...project, dimension5: e.target.value })
                          setPrjDimension5(e.target.value);
                        }}
                        onBlur={savePrjDimension5}
                      />
                      {prjDimension5Loading && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "1px", right: "-16px" }}
                          src={LoadingIcon}
                          alt="loading"
                          title="Loading..."
                        />
                      )}
                      {prjDimension5Success && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "1px", right: "-16px" }}
                          src={successIcon}
                          alt="success"
                          title="Success"
                        />
                      )}
                      {prjDimension5Error && (
                        <img
                          className="return-msg-icon"
                          style={{ top: "1px", right: "-16px" }}
                          src={errorIcon}
                          alt="error"
                          title="Error! Please reload"
                        />
                      )}
                    </div>
                  </div>
                  <div
                    className="zing-chart-div"
                    onClick={() => setShowRateDimensionPopup(true)}
                  >
                    <ZingChart id="myChart" data={chartConfig} />
                  </div>
                </div>
              </div>

              {/*------- experience and education sections */}
              <div className="ppt-right-flexible-div" style={{maxWidth:"469px"}}>
                <div className="ppt-experience-div">
                  <h5 style={{ marginBottom: "7px" }}>Relevant Experience</h5>
                  <div className="ppt-text-experience" style={{minHeight: "350px"}}>
                    {powerPointID ? (
                      <ExpertPowerPointExperience expert_id={exp_id} powerPointID={powerPointID}/>
                    ):(
                      // <p>Loading ...</p>
                      null
                    )}
                  </div>
                </div>
                <div
                  className="ppt-education-div"
                  style={{ paddingTop: "13px", background: "#fff" }}
                >
                  <h5 style={{ marginBottom: "7px" }}>
                    Education &amp; Certification
                  </h5>
                  <textarea
                    id="ppt-expert-education"
                    value={exEducation}
                    onChange={(e) => {
                      // setExpertData({ ...expertData, education: e.target.value })
                      setExEducation(e.target.value);
                    }}
                    onInput={(e) => autoGrow(e)}
                    onClick={(e) => autoGrow(e)}
                    onBlur={saveExEducation}
                  />
                  {exEducationLoading && (
                    <img
                      className="return-msg-icon"
                      style={{ top: "15px", right: "167px" }}
                      src={LoadingIcon}
                      alt="loading"
                      title="Loading..."
                    />
                  )}
                  {exEducationSuccess && (
                    <img
                      className="return-msg-icon"
                      style={{ top: "15px", right: "167px" }}
                      src={successIcon}
                      alt="success"
                      title="Success"
                    />
                  )}
                  {exEducationError && (
                    <img
                      className="return-msg-icon"
                      style={{ top: "15px", right: "167px" }}
                      src={errorIcon}
                      alt="error"
                      title="Error! Please reload"
                    />
                  )}
                </div>
              </div>
              <span className="ppt-copyright-text">
                Copyright 2025 expertpowerhouse GmbH www.expertpowerhouse.com{" "}
              </span>
            </div>
          </div>

          {/* ------------------------------- PPTX popup Rate-Dimension Layer -------------------------- */}
          {showRateDimensionPopup && (
            <div id="pptRtDi-wrapper">
              <div className="tab-pane fade show pptRtDi-div">
                <h3 className="mb-3" style={{ textAlign: "center" }}>
                  Rate the Dimensions
                </h3>
                <div className="row control-bar" data-jsref="control-bar">
                  <div
                    className="col-md-12"
                    style={{ paddingLeft: "20px", paddingRight: "20px" }}
                  >
                    <div className="form-group">
                      <label id="lbl_rate1">{prjDimension1}</label>
                      <input
                        type="number"
                        list="rate1-options"
                        className="form-control"
                        value={ratingObj.rating1}
                        onChange={(e) => {
                          if (e.target.value >= 0 && e.target.value <= 5) {
                            setRatingObj({
                              ...ratingObj,
                              rating1: e.target.value,
                            });
                          }
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <label id="lbl_rate2">{prjDimension2}</label>
                      <input
                        type="number"
                        list="rate2-options"
                        className="form-control"
                        value={ratingObj.rating2}
                        onChange={(e) => {
                          if (e.target.value >= 0 && e.target.value <= 5) {
                            setRatingObj({
                              ...ratingObj,
                              rating2: e.target.value,
                            });
                          }
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <label id="lbl_rate3">{prjDimension3}</label>
                      <input
                        type="number"
                        list="rate3-options"
                        className="form-control"
                        value={ratingObj.rating3}
                        onChange={(e) => {
                          if (e.target.value >= 0 && e.target.value <= 5) {
                            setRatingObj({
                              ...ratingObj,
                              rating3: e.target.value,
                            });
                          }
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <label id="lbl_rate4">{prjDimension4}</label>
                      <input
                        type="number"
                        list="rate4-options"
                        className="form-control"
                        value={ratingObj.rating4}
                        onChange={(e) => {
                          if (e.target.value >= 0 && e.target.value <= 5) {
                            setRatingObj({
                              ...ratingObj,
                              rating4: e.target.value,
                            });
                          }
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <label id="lbl_rate5">{prjDimension5}</label>
                      <input
                        type="number"
                        max={5}
                        list="rate5-options"
                        className="form-control"
                        value={ratingObj.rating5}
                        onChange={(e) => {
                          if (e.target.value >= 0 && e.target.value <= 5) {
                            setRatingObj({
                              ...ratingObj,
                              rating5: e.target.value,
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div style={{ textAlign: "center", position: "relative" }}>
                  <button
                    type="button"
                    className="btn base-btn"
                    onClick={saveExRatingObj}
                    // setShowRateDimensionPopup(false)
                  >
                    Done
                  </button>
                  {ratingObjLoading && (
                    <img
                      className="return-msg-icon"
                      style={{
                        top: "9px",
                        right: "80px",
                        height: "24px",
                        width: "24px",
                      }}
                      src={LoadingIcon}
                      alt="loading"
                      title="Loading..."
                    />
                  )}
                  {ratingObjSuccess && (
                    <img
                      className="return-msg-icon"
                      style={{
                        top: "9px",
                        right: "80px",
                        height: "24px",
                        width: "24px",
                      }}
                      src={successIcon}
                      alt="success"
                      title="Success"
                    />
                  )}
                  {ratingObjError && (
                    <img
                      className="return-msg-icon"
                      style={{
                        top: "9px",
                        right: "80px",
                        height: "24px",
                        width: "24px",
                      }}
                      src={errorIcon}
                      alt="error"
                      title="Error! Please reload"
                    />
                  )}
                </div>
              </div>
            </div>
          )}
          {showDivBasedOnUrl()}
        </div>
      </div>

      {pptDownloading && (
        <div className="linkedin-popup-wrapper">
          <div className="tab-pane fade show linkedin-div">
            <center>
              <p style={{ fontSize: "18px" }}>Downloading PPT . . .</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}

      {/* {pptSaving && (
        <div className="linkedin-popup-wrapper">
          <div className="tab-pane fade show linkedin-div">
            <center>
                <p style={{fontSize: '18px'}}>Saving PPT . . .</p><br />
                <img src={LoadingIcon} alt="" style={{ width: '50px', marginRight: '5px' }} />
            </center>
          </div>
        </div>
      )} */}

      {digitalUpdating && (
        <div className="linkedin-popup-wrapper">
          <div className="tab-pane fade show linkedin-div">
            <center>
              <p style={{ fontSize: "18px" }}>Updating information . . .</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </>
  );
}
